/* eslint-disable no-param-reassign */
import { capi } from '../../client';

export default {
  state: {
    marineEnabled: null,
    aviationEnabled: null,
    navionicsEnabled: null,
  },

  getters: {
    marineEnabled: (state) => state.marineEnabled,
    aviationEnabled: (state) => state.aviationEnabled,
    navionicsEnabled: (state) => state.navionicsEnabled,
    marineUrl: () => `${window.AppData.supportPublicBaseUrl}/${window.AppData.locale}/marine`,
    aviationUrl: () => `${window.AppData.supportPublicBaseUrl}/${window.AppData.locale}/aviation`,
    navionicsUrl: () => `${window.AppData.supportPublicBaseUrl}/${window.AppData.locale}/navionics`,
  },

  mutations: {
    marineEnabledUpdate(state, change) {
      state.marineEnabled = change;
    },
    aviationEnabledUpdate(state, change) {
      state.aviationEnabled = change;
    },
    navionicsEnabledUpdate(state, change) {
      state.navionicsEnabled = change;
    },
  },

  actions: {
    async fetchSystemsAvailability({ getters, commit }) {
      try {
        const { data: { rows } } = await capi.get('getDatasetValues/supportFAQLinks');
        if (rows) {
          const { data } = rows.find((r) => (r.data || {}).locale === getters.locale.replace('-', '_'));
          if (data) {
            commit('marineEnabledUpdate', data.marineSCEnabled === 'true');
            commit('aviationEnabledUpdate', data.aviationSCEnabled === 'true');
            commit('navionicsEnabledUpdate', data.navionicsSCEnabled === 'true');
          }
        } else {
          commit('marineEnabledUpdate', null);
          commit('aviationEnabledUpdate', null);
          commit('navionicsEnabledUpdate', null);
        }
      } catch (e) {
        commit('marineEnabledUpdate', null);
        commit('aviationEnabledUpdate', null);
        commit('navionicsEnabledUpdate', null);
      }
    },
  },
};
